import { axiosClient } from "@/api/axios";

export function get() {
  return axiosClient.get(`your-favourites`);
}
